import { Action } from '@ngrx/store';
import { CtrlBaseComponent } from '../../controls';
import { TokenResponseModel } from '../../models';
import { ELoggedUserStoreActions, ECurrentViewActions, TokenActions, ViewActions } from '../actions';

export function TokenReducer(state: TokenResponseModel = null, action: TokenActions): any {
    switch (action.type) {
        case ELoggedUserStoreActions.SAVE_LOGGED_USER:
            return action.payload;
        case ELoggedUserStoreActions.CLEAR_LOGGED_USER:
            return null;
        default:
            return state;
    }
}

export function ViewReducer(state: any = null, action: ViewActions): any {
    switch (action.type) {
        case ECurrentViewActions.SAVE_CURRENT_VIEW:
            return action.payload ;
        case ECurrentViewActions.CLEAR_CURRENT_VIEW:
            return null;
        default:
            return state;
    }
}
